module.exports = __webpack_public_path__ + "static/media/ic_Location.ef2b92e2.svg";